import style from "./header.module.scss";
import {canarioAirLogo, loginHeader} from "../../util/assets";
import arsw_logo from "../../assets/arsw-log.png"

import Input from "../UI/input/input";
import Button from "../UI/button/button";
import Switch from "../UI/switch/switch";
import {useEffect, useMemo, useRef, useState} from "react";
import {connect} from "react-redux";
import {checkToken, login, logout_user} from "../../thunk/login";
import {getCookie} from "../../util/cookie";
import {setFilterUser} from "../../action/login";
import {getAllDevicesByMap, thunkSelectDevicesCurrentCompany} from "../../thunk/device";
import {selectDevicesCurrentCompany, sortByCentreSearchMap} from "../../action/page";
import {config} from "../../util/config";
import {useOutsideAlerter} from "../../util/util";

function Header({
                    currentUser,
                    login,
                    checkToken,
                    setFilterUser,
                    getAllDevicesByMap,
                    logout_user,
                    thunkSelectDevicesCurrentCompany,
                    data,
                    map,
                    sortByCentreSearchMap
                }) {
    const [showWindowUser, setShowWindowUser] = useState(false);
    const [email, setEmail] = useState(false);
    const [pass, setPass] = useState(false);
    const [emailErr, setEmailErr] = useState(false);
    const [passErr, setPassErr] = useState(false);
    const userRef = useRef(null);
    useOutsideAlerter(userRef, () => {
        setShowWindowUser(!showWindowUser)
    });


    const handlerLogin = () => {
        login({email, password: pass}).catch(() => {
            setEmailErr(true);
            setPassErr(true);
        })
    }

    const handlerSwitcher = () => {
        setFilterUser({findByCompanyId: !currentUser.user.filter.findByCompanyId});
        let companyId = "";
        if (currentUser.user.companyId && currentUser.user.filter.findByCompanyId) {
            companyId = currentUser.user.companyId;
        } else {
            companyId = "all"
        }
        thunkSelectDevicesCurrentCompany({companyId: companyId});
        sortByCentreSearchMap();

        if (data.find(i => i.showOnMap) && map && companyId !== "all") {
            let bounds = new window.google.maps.LatLngBounds();
            if(!data.length) return;
            let ind = 0;
            for (let item of data) {
                if (item.companyId === companyId) {
                    bounds.extend(new window.google.maps.LatLng(item.location[0], item.location[1]));
                    ind = 1;
                }
            }
            if(!ind) return;

            map.fitBounds(bounds);
        }
    }

    return (
        <div className={style.header}>
            {/* <div className={style.headerLogo}>
                <img
                    src={arsw_logo}
                    alt=""/>
            </div> */}
            
            <div className={style.headerText}>
                Geographic Information System
            </div>
            
            <div
                className={style.login}
                onClick={() => {
                    setShowWindowUser(!showWindowUser)
                }}
            >
                <img src={loginHeader} alt=""/>
            </div>
{/* 
            {currentUser.user.company && (
                <div className={style.headerLogo1}>
                    <img
                        src={config.baseSourceUrl + currentUser.user.company.logoUrl}
                        alt=""/>
                </div>
            )} */}

            {showWindowUser && (
                <div ref={userRef} className={[style.form].join(" ")}>
                    <div
                        className={style.cross}
                        onClick={() => {
                            setShowWindowUser(!showWindowUser)
                        }}
                    ></div>
                    {!currentUser.user.email && (
                        <div className={style.loginForm}>
                            <Input
                                type={'login'}
                                title={'Login'}
                                class={style.input}
                                error={emailErr}
                                handleChange={(e) => {
                                    setEmail(e.target.value);
                                    setEmailErr(false);
                                }}/>
                            <Input
                                type={'password'}
                                title={'Password'}
                                class={style.input}
                                error={passErr}
                                handleChange={(e) => {
                                    setPass(e.target.value);
                                    setPassErr(false);
                                }}/>
                            <Button title={'Log In'} class={style.button} handleClick={handlerLogin}/>
                        </div>
                    )}

                    {currentUser.user.email && (
                        <div className={style.formLogined}>
                            {/* <div className={style.formLogined_item}>

                                <label htmlFor="">Show devices only for current user</label>
                                <Switch
                                    handleClick={handlerSwitcher}
                                    id={'theLoop'}
                                    val={currentUser.user.filter.findByCompanyId}
                                />
                            </div> */}
                            <Button title={'Log Out'} class={style.button} handleClick={logout_user}/>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}


const mapStateToProps = state => ({
    currentUser: state.currentUser,
    data: state.page.data,
});

const mapDispatchToProps = dispatch => ({
    login: (data) => dispatch(login(data)),
    checkToken: (data) => dispatch(checkToken(data)),
    setFilterUser: (data) => dispatch(setFilterUser(data)),
    getAllDevicesByMap: (data) => dispatch(getAllDevicesByMap(data)),
    logout_user: (data) => dispatch(logout_user(data)),
    thunkSelectDevicesCurrentCompany: (data) => dispatch(thunkSelectDevicesCurrentCompany(data)),
    sortByCentreSearchMap: (data) => dispatch(sortByCentreSearchMap(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Header);
